/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { AutomaticTranslatorInfo } from '../../models/automatic-translator-info';

export interface AutomaticTranslationControllerGetAutomaticTranslatorInfo$Params {
}

export function automaticTranslationControllerGetAutomaticTranslatorInfo(http: HttpClient, rootUrl: string, params?: AutomaticTranslationControllerGetAutomaticTranslatorInfo$Params, context?: HttpContext): Observable<StrictHttpResponse<AutomaticTranslatorInfo>> {
  const rb = new RequestBuilder(rootUrl, automaticTranslationControllerGetAutomaticTranslatorInfo.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<AutomaticTranslatorInfo>;
    })
  );
}

automaticTranslationControllerGetAutomaticTranslatorInfo.PATH = '/automatic-translation/automatic-translator-info';
